import { Button, ButtonSize, ButtonVariant, Modal, ModalSize, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { DEFAULT_CHAT_LANGUAGE, languages } from "@next-platform/client-common-core";

import { Col, Row } from "@/components/customComponents";

import { TranslationUpgradeModalProps } from "./types";

export const TranslationUpgradeModal = ({ isOpen, onOpenChange, onUpgradeClick }: TranslationUpgradeModalProps) => {
  const handleUpgradeClick = () => {
    if (onUpgradeClick) {
      onUpgradeClick();
    }
    onOpenChange(false);
  };

  return (
    <Modal open={isOpen} onOpenChange={onOpenChange} dismissable={true} size={ModalSize.SMALL}>
      <div className="p-2">
        <Text variant={TextVariants.HEADING_5_REGULAR} className="mb-2">
          Upgrade to Translate Bots
        </Text>

        <Col className="gap-4 mb-6">
          <Text variant={TextVariants.PARAGRAPH_SMALL_REGULAR}>
            Character translation allows you to enjoy your favorite chatbots in your preferred language. Once a chatbot is translated, it's available
            for all users in that language.
          </Text>

          <div className="mt-2">
            <Text variant={TextVariants.PARAGRAPH_MEDIUM_MEDIUM} className="mb-2">
              Available languages:
            </Text>
            <div className="grid grid-cols-2 gap-2">
              {languages
                .filter((lang: { code: string; name: string }) => lang.code !== DEFAULT_CHAT_LANGUAGE)
                .map((lang: { code: string; name: string }) => (
                  <div key={lang.code} className="flex items-center">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    <Text variant={TextVariants.PARAGRAPH_SMALL_REGULAR}>{lang.name}</Text>
                  </div>
                ))}
            </div>
          </div>

          <div className="mt-4">
            <Text variant={TextVariants.PARAGRAPH_MEDIUM_MEDIUM} className="mb-2">
              Subscription benefits:
            </Text>
            <div className="space-y-2">
              <div className="flex items-center">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>{" "}
                <Text variant={TextVariants.PARAGRAPH_SMALL_REGULAR}>Translate any character</Text>
              </div>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>{" "}
                <Text variant={TextVariants.PARAGRAPH_SMALL_REGULAR}>Access more advanced models and features</Text>
              </div>
            </div>
          </div>
        </Col>

        <Row className="justify-end mt-6">
          <Button variant={ButtonVariant.SECONDARY} size={ButtonSize.MEDIUM} onClick={() => onOpenChange(false)}>
            Close
          </Button>
          <Button variant={ButtonVariant.CONTAINED} size={ButtonSize.MEDIUM} onClick={handleUpgradeClick} className="ml-2">
            Upgrade Now
          </Button>
        </Row>
      </div>
    </Modal>
  );
};
